import React from "react";
import { Empty } from "antd";
import { useTranslation } from "react-i18next";
import BillerCard from "../biller";
import { useEffect, useState } from "react";
import PaginationComponent from "../../paginationComponet";

export default function BillerBeneGridItem({ dataSource = [] }) {
  const { t } = useTranslation();

  const [data, setData] = useState([]);
  useEffect(() => {
    setData(dataSource.slice(0, 10));
  }, [dataSource]);
  
  const handlePageChange = (currentPage, slicedData) => {
    setData(slicedData);
  };
  return (
    <>
      <div className="row px-2">
        {dataSource.length === 0 ? (
          <Empty
            description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })}
          />
        ) : (
          <div className="ft-table">
            <table className="table" style={{ cursor: "pointer" }}>
              <thead style={{ backgroundColor: "#F1F1F1" }}>
                <tr>
                  <th>
                    {t("pages.pay_bills.biller_name", {
                      defaultValue: "Biller Name",
                    })}
                  </th>
                  <th>
                    {" "}
                    {t("pages.pending_approval.consumer_number", {
                      defaultValue: "Consumer Number",
                    })}
                  </th>
                  <th>
                    {t("pages.my_accounts.casa.nickname", {
                      defaultValue: "Nick Name",
                    })}
                  </th>
                  <th>
                    {t("pages.pending_approval.operation_type", {
                      defaultValue: "Operation Type",
                    })}
                  </th>
                  <th>
                    {t("pages.pending_approval.Initiated_Date", {
                      defaultValue: "Initiated Date",
                    })}
                  </th>
                  <th>{t("common.status", { defaultValue: "Status" })}</th>
                </tr>
              </thead>
              <tbody>
                {data.map((option, index) => (
                  <BillerCard record={option} />
                ))}
              </tbody>
              <tfoot>
              <tr>
                <td colSpan="8"> 
                  {dataSource.length > 10 && (
                    <PaginationComponent
                      dataSource={dataSource}
                      pageSize={10}
                      onPageChange={handlePageChange}
                    />
                    )}
                </td>
              </tr>
            </tfoot>
            </table>
          </div>
        )}
      </div>
    </>
  );
}
